export default "__VITE_ASSET__a7dfwQOC__"